<template>
  <section class="page-block products-block" id="products-block">
    <div class="wide">
      <div class="mid">
        <div class="narrow">
          <div class="title">
            <lottie
              id="bm-products"
              :options="defaultOptions"
              v-on:animCreated="handleAnimation"
            />
            <h2>{{ $t('ProductsBlock.Title') }}</h2>
            <span>{{ $t('ProductsBlock.Descriptor') }}</span>
          </div>

          <div class="tab">
            <div class="item">
              <div>
                <img src="@/content/products/cream-reuzel-blue-340.jpg" />
              </div>
              <p>Reuzel Finest Pomade Fiber 113g</p>
            </div>
            <div class="item">
              <div>
                <img src="@/content/products/cream-reuzel-blue-113.jpg" />
              </div>
              <p>Reuzel Finest Pomade Strong Hold Blue 113g</p>
            </div>
            <div class="item">
              <div>
                <img src="@/content/products/cream-uppercut-deluxepomade-100.jpg" />
              </div>
              <p>Uppercut Deluxe Pomade 100g</p>
            </div>
            <div class="item">
              <div>
                <img src="@/content/products/cream-uppercut-mattpomade-100.jpg" />
              </div>
              <p>Uppercut matt Pomade 100g</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Lottie from '@/bm/lottie.vue';
import * as animationData from '@/bm/products/data.json';

export default {
  name: 'products-img',
  components: {
    'lottie': Lottie
  },
  data() {
    return {
      defaultOptions: {animationData: animationData.default},
      animationSpeed: 1
    }
  },
  props: {
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },

    stop: function () {
      this.anim.stop();
    },

    play: function () {
      this.anim.play();
    },

    pause: function () {
      this.anim.pause();
    },

    onSpeedChange: function () {
      this.anim.setSpeed(this.animationSpeed);
    }
  }
}
</script>
